import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconRightChevronOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M5.687.22a.75.75 0 0 1 1.061 0L18.528 12 6.748 23.78a.751.751 0 0 1-1.06-1.061L16.407 12 5.687 1.28a.75.75 0 0 1 0-1.06" /></svg>
);
